import React from 'react';
import { node } from 'prop-types'; // styles

import { StyledModalDescription } from './styles/styled';

var ModalDescription = function ModalDescription(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledModalDescription, null, children));
};

ModalDescription.propTypes = {
  children: node.isRequired
};
export default ModalDescription;